import React from 'react';
import { Flex } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { CIRCLES_WIDTH } from '../../pulse.common';
import { GraphItem } from './IterationGraphItem';

const ITEMS_LENGTH = 15;
const HorizontalLine = styled.div`
  position: absolute;
  width: ${ITEMS_LENGTH * CIRCLES_WIDTH}rem;
  height: 1px;
  z-index: 0;
  top: 50%;
  background-color: ${getColor('botticelli')};
`;

const BlankContent = styled(Flex)`
  width: ${(ITEMS_LENGTH - 1.5) * CIRCLES_WIDTH}rem;
  height: 3rem;
  background-color: ${getColor('catskillGray')};
`;

const CarryOverWrapper = styled(Flex)`
  position: absolute;
  align-items: center;
  bottom: -0.5rem;
  transform: translateY(-1rem);
`;
const IterationGraph = ({
  items = [],
  hasAlerts,
  carryover,
  isStoryGraph = true,
  selectedContributorIds = []
}) => {
  return (
    <Flex position='relative' direction='column' height='100%' justify='center'>
      <Flex position='relative' items='center' height='100%'>
        <HorizontalLine />
        {items.length ? (
          items.map(({ circles, tooltipData }, idx) => (
            <GraphItem
              key={idx}
              circles={circles}
              tooltipData={tooltipData}
              hasAlerts={hasAlerts}
              isStoryGraph={isStoryGraph}
              selectedContributorIds={selectedContributorIds}
            />
          ))
        ) : (
          <BlankContent />
        )}
      </Flex>
      {carryover && (
        <CarryOverWrapper>
          <Icon
            size='x-small'
            direction='left'
            name='Arraw'
            color='shuttleGray'
          />{' '}
          <Text pl='0.5rem' size='small' color='shuttleGray'>
            {carryover}
          </Text>
        </CarryOverWrapper>
      )}
    </Flex>
  );
};

export default IterationGraph;
